module.exports = __webpack_public_path__ + "img/52002751_L.7ac94665.png";